import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {NoScoresClickEvent} from "../models/events/no-scores-click-event";

export class NoScoresClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.noScoresClick;
  analyticsService: AnalyticsService;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NoScoresClickEvent;
  }

  async action(params) {
    const clickEvent: NoScoresClickEvent = new NoScoresClickEvent(params);

    this.analyticsService.createEvent(clickEvent);
  }
}
